module.exports = __webpack_public_path__ + "static/img/Business_environment.50b0cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/Business_environment.png
// module id = i8vk
// module chunks = 44